<script lang="ts">
    import { browser } from '$app/environment';
    import NavigationEventsNotifier from './NavigationEventsNotifier.svelte';
    import OnSessionEndedEvents from './OnSessionEndedEvents.svelte';
</script>

{#if browser}
    <!-- PUBLISHING EVENTS FOR CONSUMPTION -->
    <NavigationEventsNotifier />
    <!-- CONSUMING EVENTS FOR REACTIONS -->
    <OnSessionEndedEvents />
{/if}
